/**
 * Created by jonas on 2021-03-08.
 */
import {ArrayUtils} from "./ArrayUtils";

export class LoopableList<T> {
    private index: number;
    public list: T[]
    private _randomizeOnWrapAround: boolean = false;

    constructor(list: T[]) {
        this.index = -1;
        this.list = list;
    }

    public reset() {
        this.index = -1;
    }

    public next(): T {
        const index = this.increment()
        return this.list[index];
    }

    public setRandomizeAtWrapAround(randomize: boolean): LoopableList<T> {
        this._randomizeOnWrapAround = randomize;
        return this;
    }

    private increment(): number {
        this.index++;
        this.index %= this.list.length;
        if (this.index == 0 && this._randomizeOnWrapAround) {
            this.list = ArrayUtils.shuffleArray(this.list);
        }
        return this.index;
    }
}
